import { render, staticRenderFns } from "./MessageDateIntent.vue?vue&type=template&id=d58a2ad2"
import script from "./MessageDateIntent.vue?vue&type=script&lang=js"
export * from "./MessageDateIntent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports